import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckCircleLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "e/icon/system/check_circle_line",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM15.5354 8.38124C15.9259 7.99071 16.5591 7.99071 16.9496 8.38124C17.3101 8.74172 17.3378 9.30895 17.0328 9.70124L16.9496 9.79545L11.3635 15.3816C10.9646 15.7805 10.3355 15.809 9.90376 15.4671L9.80782 15.3816L7.0501 12.6239C6.65958 12.2334 6.65958 11.6002 7.0501 11.2097C7.41059 10.8491 7.97782 10.8214 8.3701 11.1265L8.46431 11.2097L10.5856 13.331L15.5354 8.38124Z"
		})
	})
});
export default SvgCheckCircleLine;
